/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';

import { CountUp, SlantedBanner } from 'components';
import { StepType } from 'components/Stepper';
import { ChallengeResultType } from 'interfaces';

const CustomSlantedBanner = styled(SlantedBanner)<{
  style: { [key: string]: string | number };
}>(({ style }) => ({
  minWidth: 215,
  position: 'absolute',
  width: 'auto',
  zIndex: 1,
  ...style,
}));

type Props = {
  currentStep: number;
  isLeftHidden: boolean;
  result: Partial<ChallengeResultType> | undefined;
  steps: StepType[];
  style?: { [key: string]: string | number };
};

const GenericGoalResultBanner = ({
  currentStep,
  isLeftHidden,
  result,
  steps,
  style = {},
}: Props): JSX.Element => {
  const activeStep = currentStep + 1 || undefined;

  const leftText = (
    <strong>
      {result?.rank?.toLocaleString() || '-'}
      <sup>e</sup>
    </strong>
  );
  const rightText = (
    <React.Fragment>
      <strong>
        {result?.resultValue !== undefined ? (
          <CountUp end={Number(result.resultValue)} />
        ) : (
          '-'
        )}
      </strong>
      <br />
      <small>
        <small>{activeStep ? steps?.[1]?.unit : '-'}</small>
      </small>
    </React.Fragment>
  );

  return (
    <CustomSlantedBanner
      isHighlighted
      style={style}
      isLeftHidden={isLeftHidden}
      leftText={leftText}
      rightText={rightText}
    />
  );
};

export default GenericGoalResultBanner;
